export default function MySQL_BIN() {
  return (
    <div>
      <h2>MySQL_BIN</h2>    </div>
  );
}